import React from "react";

import svg from "../../assets/images/icons/steps/Run Intersection Rule f.svg";

export const RunIntersectionRuleIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Run Intersection Rule"}
    />
);
